export const CRM_STATES = {
  OFFLINE: 1,
};

export const CRM_LOCALSTORAGE_LAST_STATE = 'crm_last_status';
export const CRM_LOCALSTORAGE_LAST_STATE_CHANGED_AT = 'crm_status_changed_at';
